import { Doughnut } from "react-chartjs-2";

const TaskDetails = ({ data = {} }) => {
    const halfDoughnutOptions = {
        responsive: true,
        maintainAspectRatio: false,
        rotation: -90,
        circumference: 180,
        cutout: "90%",
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
            },
        },
    };

    const createChartData = (values = {}) => ({
        labels: Object.keys(values),
        datasets: [
            {
                data: Object.values(values),
                backgroundColor: ["#80ffdb", "#ff4d6d"],
                borderWidth: 0,
                datalabels: {
                    display: false
                }
            },
        ],
    });

    return (
        <>
            <div className="dashboard-pie-analytics">
                <h4 className="analytics-title">Delivery Breakdown</h4>

                <div className="half-donut-chart">
                    <Doughnut
                        data={createChartData({
                            Completed: data?.delivery?.completed,
                            Pending: data?.delivery?.pending,
                        })}
                        options={halfDoughnutOptions}
                    />
                </div>

                <div className="chart-legend">
                    <div className="legend-item">
                        <span className="legend-dot completed"></span>
                        Completed
                    </div>

                    <div className="legend-item">
                        <span className="legend-dot pending"></span>
                        Pending
                    </div>
                </div>
            </div>

            <div className="dashboard-pie-analytics mt-3">
                <h4 className="analytics-title">Pickup Breakdown</h4>

                <div className="half-donut-chart">
                    <Doughnut
                        data={createChartData({
                            Completed: data?.pickup?.completed,
                            Pending: data?.pickup?.pending,
                        })}
                        options={halfDoughnutOptions}
                    />
                </div>

                <div className="chart-legend">
                    <div className="legend-item">
                        <span className="legend-dot completed"></span>
                        Completed
                    </div>

                    <div className="legend-item">
                        <span className="legend-dot pending"></span>
                        Pending
                    </div>
                </div>
            </div>
        </>
    );
};

export default TaskDetails;